import React, { useState } from 'react';
import ButtonLogin from '../../ui/Btn';
import resources from '../../services';
import logo from '../../assets/logo.png';

export default function LoginPage() {
	const [loader, setLoader] = useState(false),
		[error, setError] = useState();

	React.useEffect(() => {
		document.body.style['background-image'] = 'none';
		document.body.style['background'] = '#f2f7fb';

		// document.body?.attributes?.removeNamedItem('themebg-pattern');
	}, []);

	async function auth(e) {
		e.preventDefault();
		setLoader(true);
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		let res = await resources.auth
			.auth(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (!res) {
			setError('Server Error');
		} else {
			if (res?.status === 200) {
				if (res.data) {
					sessionStorage.setItem('token', res.data.token.token);
					sessionStorage.setItem(
						'user',
						JSON.stringify(res.data.user)
					);
					window.location.replace('/dashboard');
					setLoader(false);
				}
			} else {
				setError(res.data);
			}
		}
		setLoader(false);
	}

	return (
		<section className="login-block">
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12">
						<form
							className="md-float-material form-material  m-t-15"
							onSubmit={auth}
						>
							<div className="text-center">
								<img src={logo} width="200" alt="logo.png" />
							</div>
							<div className="auth-box card m-t-15">
								<div className="card-block">
									<div className="row m-b-20">
										<div className="col-md-12">
											<h3 className="text-center txt-primary">
												Sign In
											</h3>
										</div>
									</div>
									<p className="text-muted text-center p-b-5">
										Sign in with your regular account
									</p>
									<div className="form-group form-primary">
										<input
											className="form-control"
											type="email"
											name="email"
											required
										/>
										<span className="form-bar"></span>
										<label className="form-label float-label">
											Username
										</label>
									</div>
									<div className="form-group form-primary">
										<input
											type="password"
											name="password"
											className="form-control"
											required
										/>
										<span className="form-bar"></span>
										<label className="form-label float-label">
											Password
										</label>
									</div>
									<div className="row m-t-25 text-start"></div>
									<div className="row m-t-30">
										<div className="col-md-12">
											<div className="d-grid">
												<ButtonLogin
													type="submit"
													className="btn btn-primary btn-md waves-effect text-center m-b-20"
													onLoad={loader}
												>
													LOGIN
												</ButtonLogin>
											</div>
										</div>
									</div>
									{error && (
										<div className="alert alert-danger alert-dismissible fade show mt-3">
											<strong>
												{/* Adresse e-mail ou mot de passe incorrect! */}
												{error}
											</strong>
											<button
												type="button"
												className="btn-close"
												onClick={() => setError(false)}
											></button>
										</div>
									)}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
	);
}
